import { Skeleton } from '@chakra-ui/react';
import React from 'react';

export const ButtonSkeleton = () => {
    return <Skeleton height="40px" borderRadius="md" />;
};
